<script lang="ts">
	//ChartUtil
	import { ChartUtil } from './chartjs/chart';
	//Types
	import type { ChartDataInterface, ChartInterface } from '../../types/Chart';
	//Helpers
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let chartData: ChartDataInterface,
		chartHeight: number = chartData.height,
		disabled: boolean = chartData.disabled,
		hideTooltip: boolean = false,
		thumbMode: boolean = false;

	chartData.thumbMode = thumbMode;

	let chart: ChartInterface;
	const initChart = (container: HTMLElement, chartData: ChartDataInterface) => {
		chart = new ChartUtil(container, chartData);
		return {
			update(chartData: ChartDataInterface) {
				if (/^(tempSchedule|tariffIntervals)$/.test(chartData.name)) {
					chart.destroy();
					chart = new ChartUtil(container, chartData);
				} else if (chartData.name == 'dynamicChart') {
					chart.updateData(chartData);
				}
			},
			destroy() {
				// console.log('CHART DESTROY----', chart, $chartTooltipStore);
				chart.destroy();
			},
		};
	};
	export const getChartUtil = (): ChartInterface => {
		return chart;
	};

	let preventDrag = false,
		touchStartPosX = 0;
</script>

<div
	class={classMap({
		'chart-wrapper': true,
		'chart-disabled': disabled,
		'pointer-events-none': hideTooltip,
	})}
	style={`height: ${chartHeight}px;`}
	data-prevent-drawer-swipe
	data-prevent-sidepanel-swipe
	use:initChart={chartData}
	on:change
	on:touchstart={(e) => {
		preventDrag = false;
		touchStartPosX = e.touches?.[0]?.clientX;
	}}
	on:touchmove={(e) => {
		// NOTE This prevent scrolling the Drawer when you dragging the chart.
		if (e.cancelable) {
			if (preventDrag) {
				e.preventDefault();
			}
			if (Math.abs(e.touches?.[0]?.clientX - touchStartPosX) > 15) {
				preventDrag = true;
			}
		}
	}}
>
	{#if !hideTooltip}
		<div class="tooltip right left center" />
	{/if}
</div>

<style>
	.chart-wrapper {
		width: 100%;
		overflow: hidden;
	}

	:global(.chart-wrapper.chart-disabled > canvas) {
		opacity: 0.4;
	}

	.chart-wrapper > .tooltip {
		user-select: none;
		background: white;
		border-radius: 8px;
		color: var(--color-2);
		opacity: 0;
		pointer-events: none;
		position: absolute;
		font: var(--font-family);
		font-size: 10px;
		padding: 8px;
		max-width: calc(100% - 15px);
		z-index: 3;
	}

	:global(.chart-wrapper > .tooltip .content) {
		display: flex;
		margin-top: 6px;
	}

	:global(.chart-wrapper > .tooltip .legend),
	:global(.chart-wrapper > .tooltip .tariff) {
		overflow: hidden;
		text-overflow: ellipsis;
		text-wrap: nowrap;
		font-weight: 500;
	}

	:global(.chart-wrapper > .tooltip .legend) {
		font-weight: bold;
	}

	:global(.chart-wrapper > .tooltip .title) {
		font-size: 13px;
		font-weight: bold;
		text-align: left;
	}

	:global(.chart-wrapper > .tooltip .circle) {
		margin: 1px 5px 2px 0;
		min-width: 4px;
		border-radius: var(--radius-small);
	}

	:global(.chart-wrapper > .tooltip .c-row) {
		width: calc(100% - 8px);
	}

	:global(.chart-wrapper > .tooltip .label) {
		padding: 2px 0 5px;
		font-size: 10px;
		display: flex;
		justify-content: space-between;
	}

	:global(.chart-wrapper > .tooltip .values) {
		text-align: right;
		padding-left: 5px;
		text-wrap: nowrap;
	}

	:global(.chart-wrapper > .tooltip i.fas) {
		margin-right: 4px;
	}

	:global(.chart-wrapper > .tooltip i.fa-coins) {
		margin-left: 5px;
	}

	:global(.chart-wrapper > .tooltip i.fa-bolt) {
		background: var(--gradient-chart-consumed-energy);
	}

	:global(.chart-wrapper > .tooltip > .title > i.fas) {
		margin-left: -2px;
		margin-right: 5px;
	}
</style>
